<script setup>
import { ref, watch } from "vue";
import { Head, Link, useForm } from "@inertiajs/vue3";
import VInputReadonlyWithLabel from "@/Shared/Form/VInputReadonlyWithLabel.vue";
import VDevider from "@/Shared/VDevider.vue";
import VTitleWithBackLink from "@/Shared/VTitleWithBackLink.vue";
import VHeaderButtonEdit from "@/Shared/HeaderButton/VButtonEdit.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";

const props = defineProps({
    title: String,
    additional: Array,
    filters: Array,
    country: Object,
    menulist: Array,
    canEdit: Boolean,
    urlIndex: String,
    urlEdit: String,
});

const breadcrumbs = [
    {
        url: props.additional.urlIndex,
        label: "Country",
    },
    {
        url: "#",
        label: "Detail",
    },
];
</script>

<template>
    <Head>
        <title>Show - Country Management</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <VTitleWithBackLink
                        :href="additional.urlIndex"
                        :filters="additional.filters ?? {}"
                    >
                        Detail Country
                    </VTitleWithBackLink>
                    <div class="btn-wrapper">
                        <VHeaderButtonEdit
                            v-if="additional.canEdit"
                            :href="additional.urlEdit"
                        />
                    </div>
                </div>

                <VDevider />
                <div class="row">
                    <div class="col-lg-6">
                        <VInputReadonlyWithLabel
                            label="Code"
                            type="text"
                            :value="additional.country.code"
                        />
                    </div>
                    <div class="col-lg-6">
                        <VInputReadonlyWithLabel
                            label="Country"
                            type="text"
                            :value="additional.country.title"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
